import React from 'react';

import Col from 'react-bootstrap/lib/Col';
import Clearfix from 'react-bootstrap/lib/Clearfix';

import { ChartProvider } from '@ihme/common/web/components/';

import api from '../../../api';
import config from '../../../config';

import Highlight from './Highlight';
import DeathsChart from './DeathsChart';

const DEFAULT_FILTERS = {
    metric_id: config.defaultFactsheetsDeathsMetricId,
    measure_id: config.defaultFactsheetsDeathsMeasureId,
    age_group_id: config.defaultFactsheetsDeathsAgeGroupId,
    cause_id: config.defaultFactsheetsDeathsCauseId
};

type Props = {
    locationId: number;
};

const Deaths = (props: Props) => {
    const { locationId } = props;

    const filters = {
        ...DEFAULT_FILTERS,
        location_id: `${config.globalLocationId},${locationId}`
    };

    return (
        <ChartProvider
            key={locationId.toString()}
            loadFilters={() => Promise.resolve({})}
            loadData={api.data.getCauseOutcomeRecords}
            defaultFilters={filters}
        >
            <Col xs={12} md={9} mdPush={3}>
                <DeathsChart locationId={locationId} />
            </Col>
            <Col xs={12} md={3} mdPull={9}>
                <Highlight locationId={locationId} />
            </Col>
            <Clearfix />
        </ChartProvider>
    );
};

export default Deaths;
